/* Keep coverage aligned with the existing picker without changing purchase behaviour.
   Without JavaScript all named plan profiles remain readable in the initial HTML. */
if (!customElements.get('tsa-coverage-plans')) {
  customElements.define('tsa-coverage-plans', class extends HTMLElement {
    connectedCallback() {
      this.picker = document.getElementById('tsaVariants');
      if (!this.picker) return;
      this.sync = () => {
        const selected = this.picker.querySelector('.tsa-product__variant-input:checked');
        const panels = Array.from(this.querySelectorAll('[data-coverage-variant]'));
        const known = selected && panels.some(panel => panel.dataset.coverageVariant === selected.value);
        panels.forEach(panel => { panel.hidden = !!known && panel.dataset.coverageVariant !== selected.value; });
      };
      this.picker.addEventListener('change', this.sync);
      window.addEventListener('pageshow', this.sync);
      this.sync();
    }
    disconnectedCallback() {
      if (!this.sync) return;
      this.picker.removeEventListener('change', this.sync);
      window.removeEventListener('pageshow', this.sync);
    }
  });
}
